import { useState } from 'react'

import axios from 'axios'

export const SUCCESS_PATH = '/discover/form-success'

function useLeadForm({ form, captchaId }) {
  const [isCaptchaRequested, setIsCaptchaRequested] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)

  const handleFocus = () => setIsCaptchaRequested(true)

  const handleSubmit = (event) => {
    event.preventDefault()
    setIsCaptchaRequested(true)

    if (isSubmitting) return

    const captchaToken = window.mtcaptcha?.getVerifiedToken(captchaId)

    if (!captchaToken) {
      setError('captcha')
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const fields = Object.fromEntries(new FormData(event.currentTarget))

    setIsSubmitting(true)
    setError(null)

    axios.post(
      `/api/internal/landing-leads/${form}`,
      { ...fields, MTCaptchaToken: captchaToken },
      { headers: { 'X-CSRF-Token': csrfToken } },
    ).then(() => {
      window.location.assign(SUCCESS_PATH)
    }).catch((requestError) => {
      const isCaptchaError = requestError.response?.data?.errors?.includes('captcha')

      setError(isCaptchaError ? 'captcha' : 'generic')
      setIsSubmitting(false)
      window.mtcaptcha?.resetUI(captchaId)
    })
  }

  return { handleFocus, handleSubmit, isCaptchaRequested, isSubmitting, error }
}

export default useLeadForm
